export const inSensitiveSearch = (str1, str2) => {
  const thisStr = str1.toLowerCase();
  const toBeMatchedStr = str2.toLowerCase();

  return thisStr.includes(toBeMatchedStr);
};
